/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Row,
  Col, 
  Card,
  CardHeader,
  CardBody 
} from 'reactstrap'; 
// import FeedbackCoaching from './FeedbackCoaching.jsx'; 
import Highcharts from 'highcharts';
import { config } from '../../../../utils/config';
import { callApi,showSweetAlert } from '../../../../utils/utils';   
import 'devextreme/dist/css/dx.light.css';  
import DailyOperationProductionTrendSkeleton from './DailyOperationProductionTrendSkeleton'; 
import { Column } from 'primereact/column';
import FieldDataTable from 'components/Controls/FieldDataTable/FieldDataTable';
import moment from "moment"; 
import FieldButton from 'components/Controls/FieldButton/FieldButton';
import { Dialog } from 'primereact/dialog';
import FieldTextArea from 'components/Controls/FieldTextArea';
import FieldDropdown from 'components/Controls/FieldDropdown';
import { set } from 'date-fns';
import * as yup from 'yup';
import YupValidator from '../../../../utils/YupValidator';


const DailyOperationProductionTrendDetail = (props) => {
  /* ################## useState area start ################## */
  const { t } = useTranslation(['wtw', 'common']);  
  const [IsLoading, setIsLoading] = useState(false);  
  const [Detalle, setDetalle] = useState([]);
  const [Downtime, setDowntime] = useState([]);
  const [Comentarios, setComentarios] = useState([]);
  const DetalleExportGrid = useRef(null);
  const DowntimeExportGrid = useRef(null);
  const ComentariosExportGrid = useRef(null);
  const [EsAgregarComentarioWorkCenter, setEsAgregarComentarioWorkCenter] = useState(false);
  const [PosibleSolucionProblema, setPosibleSolucionProblema] = useState(null);
  const [ExplicacionProblema, setExplicacionProblema] = useState(null);
  const [errors, setErrors] = useState({});   
  const [ClaTurno, setClaTurno] = useState(null);
  const [OpcionesTurnos, setOpcionesTurnos] = useState([]);

  useEffect(() => {
    console.log('DailyOperationProductionTrendDetail props',props); 
    getTredDetail(); 
    getTurnos();
  }, []);  


  const CajasTemplate = (item, columnName, decimals) => {
    return (
      <> 
        <span>{Highcharts.numberFormat(item[columnName],decimals, '.', ',')} </span>
      </>
      );
  };  
  
  const DecimalTemplate = (item, columnName, decimals) => {
    
    return (
      <> 
        <span>{Highcharts.numberFormat(item[columnName],decimals, '.', ',')}</span>
      </>
      );
  };  
  
  const HorasParoTemplate = (item) => {
    
    return (
      <> 
        <span>{Highcharts.numberFormat(item.HorasParo,2, '.', ',')}</span>&nbsp;
        <span>({item.ConteoParos})</span>
      </>
      );
  };  
  const PorcentajeTemplate = (item, columnName) => {
    
    return (
      <> 
        <span>{Highcharts.numberFormat(item[columnName],2, '.', ',')}%</span>
      </>
      );
  };  

  const DateTemplate = (item, columnName) => {
    const dateValue = item[columnName];
    return (
      <> 
        <span> 
          <span>
            { dateValue ? moment(dateValue).format('MMMM DD, YYYY') : '' }
          </span>
        </span>
      </>
      );
  };  

  
  const NomArticuloTemplate = (item) => { 
    return (
      <> 
        <span>   
          {item.ClaveArticulo} - {item.NomArticulo}
        </span>
      </>
      );
  };  

  const getTredDetail = () => {  
    const urlWebService = `${config.UrlApiProject}WTW/GetProduccionSeguimientoTendenciaDiariaDetalle`; 
    const paramsService = {
      ClaUbicacion:props.ClaUbicacion,
      ClaAnio:props.Anio, 
      ClaMes:props.Mes, 
      ClaArea:props.ClaArea, 
      ClaMaquina:props.ClaMaquina, 
      Fecha:props.Fecha
    }; 
    callApi(urlWebService, 'POST', paramsService, (response) => {  
      setIsLoading(false);
      setDetalle(response.data.ProduccionSeguimientoTendenciaDiariaDetalle);
      setDowntime(response.data.ProduccionSeguimientoTendenciaDiariaDowntime);
      setComentarios(response.data.ProduccionSeguimientoTendenciaDiariaComentario);
    }, null, false, false);
  }

  const ExportExcelDetail = (pIdEncuesta) => { 
    const ExportarSurvey = `${config.UrlApiProject}WTW/ExportarProduccionSeguimientoTendenciaDiariaDetalle`;        
    const paramsService = {
      ClaUbicacion:props.ClaUbicacion,
      ClaAnio:props.Anio, 
      ClaMes:props.Mes, 
      ClaArea:props.ClaArea, 
      ClaMaquina:props.ClaMaquina, 
      Fecha:props.Fecha,
      PropiedadesDetalle:[
        ...(props.Fecha === null ? [{ ColumnKey: "Fecha", ColumnName: t('wtw:Date'), ColumnType: "DATE"}] : []),
        { ColumnKey: "NomTurno", ColumnName: t('wtw:Shift'), ColumnType: "VARCHAR" },
        { ColumnKey: "NomArticulo", ColumnName: t('wtw:Item'), ColumnType: "VARCHAR" },
        { ColumnKey: "UnitsByHr", ColumnName: t('wtw:UnitsByHr'), ColumnType: "INT" },
        { ColumnKey: "Utilizacion", ColumnName: t('wtw:Utilizacion'), ColumnType: "INT" },
        { ColumnKey: "Efficiencia", ColumnName: t('wtw:Efficiencia'), ColumnType: "INT" },
        { ColumnKey: "Scrap", ColumnName: t('wtw:Scrap'), ColumnType: "INT" },
        { ColumnKey: "OEE", ColumnName: t('wtw:OEE'), ColumnType: "INT" },
        { ColumnKey: "Tons", ColumnName: t('wtw:Tons'), ColumnType: "INT" },
        { ColumnKey: "Cajas", ColumnName: t('wtw:Units'), ColumnType: "INT" },
        { ColumnKey: "Disponibilidad", ColumnName: t('wtw:Disponibilidad'), ColumnType: "INT"}
      ],
      PropiedadesDownTime:[
        ...(props.Fecha === null ? [{ ColumnKey: "Fecha", ColumnName: t('wtw:Date'), ColumnType: "DATE" }] : []),
        { ColumnKey: "NomTurno", ColumnName: t('wtw:Shift'), ColumnType: "VARCHAR" },
        { ColumnKey: "NomGpoParo", ColumnName: t('wtw:Group'), ColumnType: "VARCHAR" },
        { ColumnKey: "NomSeccionParo", ColumnName: t('wtw:Type'), ColumnType: "VARCHAR" },
        { ColumnKey: "HorasParo", ColumnName: t('wtw:Hours'), ColumnType: "INT" }
      ],
      PropiedadesComentario:[
        ...(props.Fecha === null ? [{ ColumnKey: "Fecha", ColumnName: t('wtw:Date'), ColumnType: "DATE" }] : []),
        { ColumnKey: "NomTurno", ColumnName: t('wtw:Shift'), ColumnType: "VARCHAR" },
        { ColumnKey: "ExplicacionProblema", ColumnName: t('wtw:Problem'), ColumnType: "VARCHAR" },
        { ColumnKey: "PosibleSolucionProblema", ColumnName: t('wtw:Solution'), ColumnType: "VARCHAR" }
      ]
    }; 
    callApi(ExportarSurvey, 'POST', paramsService, (response) => {
      const linkSource = `data:application/${response.data.FileExtension};base64,${response.data.FileData}`;
      const downloadLink = document.createElement("a");
      const fileName = `${response.data.FileName}`;
      downloadLink.href = linkSource;
      downloadLink.download = `${fileName  }.${  response.data.FileExtension}`;
      downloadLink.click();
    });    
  };

  const headerDialogAgregarComentarioWorkCenter = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>
          {props.NomMaquina}
        </span>
        <span className='pr-2'>
          {
            props.Fecha !== null 
              ? moment(props.Fecha).format('MMMM, D, YYYY') 
              : ''
          }
        </span>
      </div>
    );
  }

  const footerDialogAgregarComentarioWorkCenter = () => {
    return (
      <div style={{ textAlign: 'center' }}>
        <FieldButton
          label={t('wtw:Save')}
          icon="pi pi-save"
          className="p-button-success no-border p-mr-2 "
          onClick={() => onSaveAgregarComentario()}
        >
        </FieldButton>
      </div>
    );
  }

  
 const AddNewComment = () => {
    setClaTurno(null);
    setPosibleSolucionProblema(null);
    setExplicacionProblema(null);
    setErrors({});
    setEsAgregarComentarioWorkCenter(true); 
 } 

 const onChangeExplicacionProblema = (e) => {   
  setExplicacionProblema(e.target.value); 
}
 

const onChangePosibleSolucionProblema = (e) => {   
  setPosibleSolucionProblema(e.target.value) 
}

const onTurnoChange = (e) => {  
    const newErrors = { ...errors } 
    delete newErrors.ClaTurno;   
    setErrors(newErrors)  
    setClaTurno(e.value);   
  };

  const getTurnos = (ClaUbicacion) => {  
      const urlWebService = `${config.UrlApiProject}turno/getTurnos?ClaUbicacion=${props.ClaUbicacion===null?'':props.ClaUbicacion}`; 
      const paramsService= {};  
      callApi(urlWebService, 'GET', paramsService, (response) => {
        setOpcionesTurnos(response.data.Turnos); 
      }, null, false, false);
    }

    const agregarComentarioValitationSchemeSave = yup.object().shape({
        ClaTurno: yup.mixed().required(t('common:RequiredField')).nullable(),
        PosibleSolucionProblema: yup.string().required(t('common:RequiredField')).nullable(),
        ExplicacionProblema: yup.string().required(t('common:RequiredField')).nullable(), 
    });

    const getComentario = () => {
      const ProduccionParoList = [];
     
      let data = {}
      
      data = {}
      data.ClaTurno = ClaTurno;
      data.Fecha = props.Fecha;
      data.ClaMaquina = props.ClaMaquina;
      data.ClaUbicacion = props.ClaUbicacion; 
      data.IdProduccionSeguimientoDiario = null;
      data.ExplicacionProblema = ExplicacionProblema;
      data.PosibleSolucionProblema = PosibleSolucionProblema;
      ProduccionParoList.push(data); 
       
      return ProduccionParoList
    }


    const onSaveAgregarComentario = async () => {
       const value = {
          ClaTurno,
          PosibleSolucionProblema,
          ExplicacionProblema
        };
    
        const validator = new YupValidator(agregarComentarioValitationSchemeSave);
        const esValido = await validator.validate(value);
        if (!esValido) { 
          setErrors(validator.errors);
          showSweetAlert(t('common:Warning'), t('common:ReviewRequiredFields'), 'warning');
          return;
        }
     
        const urlWebServiceSave = `${config.UrlApiProject}WTW/SaveProduccionSeguimientoDiario`;
        
        const paramsService = {
          ProduccionSeguimientoDiario:getComentario()
        }; 
 
    
        callApi(urlWebServiceSave, 'POST', paramsService, (response) => {
          showSweetAlert(t('common:Exito'), t('common:SaveSuccess'), 'success');
          setErrors({});
          setEsAgregarComentarioWorkCenter(false);
           getTredDetail(); 
        });  
    }
  
 
 
  return (
    <> 
      <div> 
        {IsLoading ? (
          <DailyOperationProductionTrendSkeleton />
        ) : (
          <>
            <Row className='pb-2'>
              <Col>
                <h2>{t('wtw:DetailByItem')}</h2>
              </Col>
              <Col className='text-right'>
                <FieldButton
                  label={t('common:Export')} 
                  icon="fa fa-file-excel"
                  className="p-button p-highlight warning no-border" 
                  onClick={() => ExportExcelDetail()}
                >              
                </FieldButton> 
              </Col> 
            </Row>
            <Row>
              <Col>
                <FieldDataTable 
                  value={Detalle}  
                  refererence={DetalleExportGrid}  
                  paginator={false}
                > 
                  {props.Fecha === null && <Column header={t('wtw:Date')} className='text-left' headerStyle={{ width: '120px' }} body={(rowData)=> DateTemplate (rowData, 'Fecha')}></Column>}                
                  <Column field="NomTurno" header={t('wtw:Shift')} className='text-center' headerStyle={{ width: '100px' }} columnKey="NomTurno"></Column> 
                  <Column field="NomArticulo" header={t('wtw:Item')} body={(rowData)=> NomArticuloTemplate (rowData, 'NomArticulo')} headerStyle={{ width: '300px' }} columnKey="NomArticulo"></Column> 
                  <Column header={t('wtw:UnitsByHr')} className='text-center' headerStyle={{ width: '90px' }} body={(rowData)=> DecimalTemplate (rowData, 'UnitsByHr', 2)}></Column>
                  <Column header={t('wtw:Utilizacion')} className='text-right' headerStyle={{ width: '80px' }} body={(rowData)=> PorcentajeTemplate (rowData, 'Utilizacion')}></Column> 
                  <Column header={t('wtw:Efficiencia')} className='text-right' headerStyle={{ width: '80px' }} body={(rowData)=> PorcentajeTemplate (rowData, 'Efficiencia')}></Column>
                  <Column header={t('wtw:Scrap')} className='text-right' headerStyle={{ width: '90px' }} body={(rowData)=> PorcentajeTemplate (rowData, 'Scrap')}></Column>
                  <Column header={t('wtw:OEE')} className='text-right' headerStyle={{ width: '80px' }} body={(rowData)=> PorcentajeTemplate (rowData, 'OEE')}></Column>
                  <Column header={t('wtw:Tons')} className='text-right' headerStyle={{ width: '90px' }} body={(rowData)=> DecimalTemplate (rowData, 'Tons', 2)}></Column>
                  <Column header={t('wtw:Units')} className='text-right' headerStyle={{ width: '90px' }} body={(rowData)=> CajasTemplate (rowData, 'Cajas', 0)}></Column>
                  <Column header={t('wtw:Disponibilidad')} className='text-right' headerStyle={{ width: '80px' }} body={(rowData)=> PorcentajeTemplate (rowData, 'Disponibilidad')}></Column>
                </FieldDataTable>
              </Col> 
            </Row> 
            <Row>
              <Col>
                <h2>{t('wtw:Downtimes')}</h2>
              </Col>
            </Row>
            <Row className='pb-2'>
              <Col>
                <FieldDataTable 
                  value={Downtime}    
                  paginator={false}
                  refererence={DowntimeExportGrid}
                >  
                  {props.Fecha === null && <Column header={t('wtw:Date')} className='text-left' headerStyle={{ width: '120px' }} body={(rowData)=> DateTemplate (rowData, 'Fecha')}></Column>}    
                  <Column field="NomTurno" header={t('wtw:Shift')} className='text-center' headerStyle={{ width: '100px' }} columnKey="NomTurno"></Column> 
                  <Column field="NomGpoParo" header={t('wtw:Group')} headerStyle={{ width: '300px' }} columnKey="NomGpoParo"></Column> 
                  <Column field="NomSeccionParo" header={t('wtw:Type')} headerStyle={{ width: '300px' }} columnKey="NomSeccionParo"></Column> 
                  <Column field="HorasParo" header={t('wtw:Hours')} headerStyle={{ width: '100px' }} body={(rowData)=> HorasParoTemplate (rowData)} columnKey="HorasParo"></Column> 
                </FieldDataTable>
              </Col> 
            </Row> 
            <Row className='pb-2'>
              <Col>
                <h2>{t('wtw:DailyCommentsDetail')}</h2>
              </Col> 
              <Col className='text-right'>
                {
                  (props.ClaMaquina !== null && props.Fecha !== null)  &&
                  (
                    <FieldButton
                      label={t('wtw:AddNewComment')} 
                      icon="fas fa-plus-square"
                      className="p-button p-highlight primary no-border" 
                      onClick={() => AddNewComment()}
                    >              
                    </FieldButton> 
                  )
                }
               
              </Col>
            </Row>
            <Row className='pb-2'>
              <Col>
                <FieldDataTable 
                  value={Comentarios}     
                  refererence={ComentariosExportGrid}
                  paginator={false}
                > 
                  {props.Fecha === null && <Column header={t('wtw:Date')} className='text-left' headerStyle={{ width: '120px' }} body={(rowData)=> DateTemplate (rowData, 'Fecha')}></Column>}    
                  <Column field="NomTurno" header={t('wtw:Shift')} className='text-center' headerStyle={{ width: '100px' }} columnKey="NomTurno"></Column> 
                  <Column field="ExplicacionProblema" header={t('wtw:Problem')} headerStyle={{ width: '350px' }} columnKey="ExplicacionProblema"></Column> 
                  <Column field="PosibleSolucionProblema" header={t('wtw:Solution')} headerStyle={{ width: '350px' }} columnKey="PosibleSolucionProblema"></Column> 
                </FieldDataTable>
              </Col> 
            </Row>
          </>
        )}

        <Dialog
          visible={EsAgregarComentarioWorkCenter}
          modal 
          header={headerDialogAgregarComentarioWorkCenter}
          footer={footerDialogAgregarComentarioWorkCenter}
          className="DailyOperationAssetDetailTree dialog-header-background-blue"
          style={{ width: '85vw' }}
          maximized={false}
          draggable={false} 
          onHide={() => setEsAgregarComentarioWorkCenter(false)}
        >
          <div className='pt-3'>
            <Row>
              <Col>
                <b>{`${t('wtw:Shift')}`}</b>
                <div className="p-fluid">
                  <FieldDropdown  
                    name="ClaTurno"
                    value={ClaTurno} 
                    options={OpcionesTurnos}  
                    optionValue="ClaTurno"
                    optionLabel="NomTurno" 
                    onChange={(e) => onTurnoChange(e)} 
                    errors={errors}
                  />   
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <table width="100%"> 
                  <tbody>
                    <tr className='pb-3'>  
                      <td width="35%" style={{verticalAlign:"top"}}>
                        <b>{`${t('wtw:Problem')}`}</b>
                        <div className="p-fluid">
                          <FieldTextArea 
                            name="ExplicacionProblema"
                            rows={2}
                            value={ExplicacionProblema}  
                            onChange={(e) => onChangeExplicacionProblema(e)}  
                            errors={errors}
                            maxLength={3000}
                            placeholder={t('wtw:ExplicacionProblema')}
                          />
                        </div>
                      </td>
                      <td width="35%" style={{verticalAlign:"top"}}>
                        <b>{`${t('wtw:Solution')}`}</b>
                        <div className="p-fluid">
                          <FieldTextArea 
                            name="PosibleSolucionProblema"
                            rows={2}
                            value={PosibleSolucionProblema}  
                            onChange={(e) => onChangePosibleSolucionProblema(e)}  
                            errors={errors}
                            maxLength={3000}
                            placeholder={t('wtw:PosibleSolucionProblema')}
                          />
                        </div>
                      </td>
                    </tr>  
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>
        </Dialog>  

      </div>  
    </>
  );
};

export default DailyOperationProductionTrendDetail;

